// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import GearSvg from '@rsuite/icon-font/lib/action/Gear';
var Gear = createSvgIcon({
  as: GearSvg,
  ariaLabel: 'gear',
  category: 'action',
  displayName: 'Gear'
});
export default Gear;